import { TileKit } from '@carvana/merch-search';
import type React from 'react';
import { withErrorBoundary } from '@/ErrorBoundary';
import { VehicleContextProvider } from '~/contexts/VehicleContext';
import type { Vehicle } from '~/contracts';
import BottomFrame from './BottomFrame';
import MiddleFrame from './MiddleFrame';
import {
  useCdnBlobUrl,
  useSetSearchRequestIdCookie,
  useVehicleHref
} from './ResultTile.helpers';
import TopFrame from './TopFrame';
import useSendTileInfoEvent from './useSendTileInfoEvent';

interface ResultTileProps {
  openSoftPullModal?: () => void;
  vehicle?: Vehicle;
}

const ResultTile: React.VFC<ResultTileProps> = ({
  openSoftPullModal = () => {},
  vehicle
}) => {
  const cdnBlobUrl = useCdnBlobUrl();
  const setSearchRequestCookieId = useSetSearchRequestIdCookie();
  const sendTileInfoEvent = useSendTileInfoEvent();
  const href = useVehicleHref(vehicle);

  const handleOnClick = () => {
    setSearchRequestCookieId();
    sendTileInfoEvent(vehicle);
  };

  return (
    <div
      className="result-tile m:border m:border-grey-2 m:border-solid m:rounded-md"
      data-qa="result-tile"
      id={`vehicle-${vehicle?.vehicleId}`}
    >
      <a href={href} onClick={handleOnClick}>
        <TileKit.Shell vehicle={vehicle} cdnBlobUrl={cdnBlobUrl}>
          <TopFrame />
          <MiddleFrame openSoftPullModal={openSoftPullModal} />
          <BottomFrame />
        </TileKit.Shell>
      </a>
    </div>
  );
};

const ResultTileWithProvider = props => (
  <VehicleContextProvider vehicle={props.vehicle}>
    <ResultTile {...props} />
  </VehicleContextProvider>
);

export default withErrorBoundary(ResultTileWithProvider);
